document.addEventListener('DOMContentLoaded', function() {
  const currentPath = window.location.pathname;
  const menuLinks = document.querySelectorAll('header a, nav a');
  
  menuLinks.forEach(link => {
    try {
      const linkPath = new URL(link.href).pathname;
      if (linkPath === currentPath) {
        link.style.color = '#FFFFFF';
        link.style.fontWeight = 'bold';
      }
    } catch (e) {
      // Ignoriere ungültige Links
    }
  });
});

